import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface CodeGraphNode {
  id: string;
  label: string;
  name: string;
  repoName: string;
}

export interface CodeGraphEdge {
  id: string;
  source: string;
  target: string;
  type: string;
  relationship: string;
}

export interface CodeGraphMeta {
  nodeCount: number;
  edgeCount: number;
  hasMoreNodes: boolean;
}

export interface CodeGraphResponse {
  scope: 'repository' | 'combined';
  repoName: string | null;
  nodes: CodeGraphNode[];
  edges: CodeGraphEdge[];
  meta: CodeGraphMeta;
}

export interface TrackedRepositoryStatus {
  repoName: string;
  status: string;
}

export interface TrackedRepositoriesResponse {
  repoNames: string[];
  repos: TrackedRepositoryStatus[];
}

export interface TriggerIngestionResponse {
  results: Array<{ repoName: string; success: boolean; body?: unknown; error?: string }>;
}

@Injectable({
  providedIn: 'root'
})
export class CodeGraph {
  private baseUrl = `${environment.apiUrl}/code-graph`;

  constructor(private http: HttpClient) {}

  getGraph(connectionId: string, repo?: string, nodeOffset = 0, limitNodes = 300, limitEdges = 20000): Observable<CodeGraphResponse> {
    let params = new HttpParams()
      .set('connectionId', connectionId)
      .set('node_offset', nodeOffset)
      .set('limit_nodes', limitNodes)
      .set('limit_edges', limitEdges);
    if (repo) {
      params = params.set('repo', repo);
    }
    return this.http.get<CodeGraphResponse>(this.baseUrl, { params });
  }

  getSelectedRepos(connectionId: string): Observable<TrackedRepositoriesResponse> {
    return this.http.get<TrackedRepositoriesResponse>(`${this.baseUrl}/connections/${connectionId}/selected-repos`);
  }

  setSelectedRepos(connectionId: string, repoNames: string[]): Observable<TrackedRepositoriesResponse> {
    return this.http.put<TrackedRepositoriesResponse>(`${this.baseUrl}/connections/${connectionId}/selected-repos`, { repoNames });
  }

  triggerIngestion(connectionId: string, repo?: string): Observable<TriggerIngestionResponse> {
    let params = new HttpParams();
    if (repo) {
      params = params.set('repo', repo);
    }
    return this.http.post<TriggerIngestionResponse>(`${this.baseUrl}/connections/${connectionId}/trigger`, {}, { params });
  }

  uningest(connectionId: string, repo: string): Observable<{ repoName: string; success: boolean }> {
    const params = new HttpParams().set('repo', repo);
    return this.http.post<{ repoName: string; success: boolean }>(
      `${this.baseUrl}/connections/${connectionId}/uningest`,
      {},
      { params }
    );
  }
}
